export default {
    common: {
        title: 'IA de Conteúdo',
        socialPlanner: 'Planejador Social',
        blog: 'Blog',
        funnel: 'Funil',
        website: 'Site',
        mediaLibrary: 'Biblioteca de mídia',
        email: 'Email',
        words: 'Palavras',
        variations: 'Variações',
        thisIsPaidService: 'Essa funcionalidade é um serviço pago e incorrerá em taxas de acordo com o seu uso',
        all: 'Alle',
    },
};
